module.exports = __webpack_public_path__ + "img/ZHAW_Logo.d4e414fb.svg";